import { useState, useEffect, useRef } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Badge } from "@/components/ui/badge";
import { LoadingScreen } from "@/components/layout/LoadingScreen";

export function MovimientosTab() {
  const { authAxios } = useAuth();
  const authAxiosRef = useRef(authAxios);
  authAxiosRef.current = authAxios;
  const [movements, setMovements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    authAxiosRef.current.get("/menu/movements")
      .then(res => { setMovements(res.data); setLoading(false); })
      .catch(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <LoadingScreen />;

  return (
    <div data-testid="movimientos-tab">
      <p className="text-sm text-gray-500 mb-4">Registro de entradas y salidas de insumos y productos.</p>
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-100 text-gray-500 text-xs uppercase">
              <th className="text-left p-3 font-medium">Fecha</th>
              <th className="text-left p-3 font-medium">Tipo</th>
              <th className="text-left p-3 font-medium">Descripcion</th>
              <th className="text-center p-3 font-medium">Cantidad</th>
              <th className="text-left p-3 font-medium">Usuario</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {movements.map(m => (
              <tr key={m.id} className="hover:bg-gray-50">
                <td className="p-3 text-gray-600">{new Date(m.created_at).toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" })}</td>
                <td className="p-3"><Badge className={m.type === "entry" ? "bg-emerald-100 text-emerald-700" : "bg-red-100 text-red-700"}>{m.type === "entry" ? "Entrada" : "Salida"}</Badge></td>
                <td className="p-3">{m.description || "-"}</td>
                <td className="p-3 text-center font-medium">{m.quantity}</td>
                <td className="p-3 text-gray-600">{m.user_name || "-"}</td>
              </tr>
            ))}
            {movements.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-gray-400">Sin movimientos registrados</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
